import Course from "./Course";
import CourseDetails from "./CourseDetails/CourseDetails";
import { useAppSelector } from "@/stores/hook";

export default function CourseIndex() {
  const { isCourseDetails } = useAppSelector((state) => state.educationSlice);

  return (
    <div className="m-4">
      {isCourseDetails ? <CourseDetails /> : <Course />}
    </div>
  );
}
